/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { DropdownSkeleton, ComboBox } from 'carbon-components-react';
import PropTypes from 'prop-types';
import AuditRepository from '../../../helpers/api/AuditRepository';

export default class OnBehalfWorkSiteComboBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: [],
    };
    this.onChange = this.onChange.bind(this);
    this.repository = new AuditRepository();
  }

  async componentDidMount() {
    if (!this.props.division) return;
    this.setState({ loading: true });
    const items = await this.getItems();
    this.setState({ items, loading: false });
  }

  onChange = (selectedItem) => {
    const item = selectedItem ? selectedItem.selectedItem : null;
    this.props.onChange(item);
  };

  getItems = async () => {
    let items = [];
    try {
      items = await this.repository.getWorkSites(this.props.division);
    } catch (error) {
        console.error(error);
      this.props.onError(error);
    }
    return items;
  };

  render() {
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : (
      <ComboBox
        id="comboBoxWorkSite"
        invalid={this.props.invalid}
        invalidText={this.props.invalidText}
        disabled={this.state.items < 1 || this.props.disabled}
        placeholder="Choose a Worksite"
        items={this.state.items}
        onChange={this.onChange}
        shouldFilterItem={({ item, inputValue }) =>
          item.name.toLowerCase().includes(inputValue.toLowerCase()) ||
          item.code.toLowerCase().includes(inputValue.toLowerCase())
        }
        itemToString={(item) => (item ? item && item.name : '')}
        selectedItem={this.props.selectedItem}
      />
    );
  }
}

OnBehalfWorkSiteComboBox.propTypes = {
  division: PropTypes.string.isRequired,
  invalid: PropTypes.bool,
  invalidText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  selectedItem: PropTypes.object,
  disabled: PropTypes.bool,
};
OnBehalfWorkSiteComboBox.defaultProps = {
  invalid: false,
  invalidText: '',
  selectedItem: null,
  disabled: true,
};
